import { useEffect } from 'react';

/**
 * The marketing bundle no longer hosts a sign-in dialog (2026-09-06). Every
 * join / sign-in link on these documents is a plain navigation to /auth — the
 * ONE door (src/shared-web/inbound-door.ts), the same one the SPA's CTAs and
 * the texts to an unregistered caller point at — so the old DoorProvider, the
 * MessagesDoor it raised and the /api/me it fetched to decide whether to raise
 * it are gone with it.
 *
 * What remains is the legacy address: `?signin=1&next=…` (or `?from=join|
 * dashboard|trial`) used to mean "show the dialog here". Nothing mints those
 * URLs any more (every entrance points at /auth since 2026-08-31), but they
 * are live in shipped ad creative, in authored content published before the
 * change and in texts already sent. So a document that lands with the flag
 * goes straight to /auth carrying the same destination — the same translation
 * the SPA homepage does (EmberApp.tsx) — instead of stranding the reader.
 */
export function LegacySignInRedirect(): null {
  useEffect(() => {
    let q: URLSearchParams;
    try { q = new URLSearchParams(window.location.search); } catch { return; }
    const from = (q.get('from') || '').trim();
    const asked = q.get('signin') === '1' || from === 'join' || from === 'dashboard' || from === 'trial';
    if (!asked) return;
    const raw = (q.get('next') || '').trim().slice(0, 512);
    const safe = raw.startsWith('/') && !raw.startsWith('//') && !raw.includes('\\') && !raw.includes('://');
    const fallback = from === 'dashboard' ? '/me' : '/collect';
    const next = safe ? raw : fallback;
    const arrival = from === 'trial' || from === 'dashboard' ? `&arrival=${from}` : '';
    window.location.replace(`/auth?returnTo=${encodeURIComponent(next)}${arrival}`);
  }, []);
  return null;
}
